import { render, staticRenderFns } from "./LoteProducaoCausasMortalidadeTabela.vue?vue&type=template&id=a71202d2&"
import script from "./LoteProducaoCausasMortalidadeTabela.vue?vue&type=script&lang=js&"
export * from "./LoteProducaoCausasMortalidadeTabela.vue?vue&type=script&lang=js&"
import style0 from "./LoteProducaoCausasMortalidadeTabela.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VFlex,VLayout})
